import IStore from "models/IStore";
import IUserCookieModel from "models/common-models/IUserCookieModel";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import OneSignal from "react-onesignal";
import { useSelector } from "react-redux";
import { getOneSignalEnv } from "utilities/EnvUtility";
import "./Notification.css";

interface IProps {
  readonly mouseLeave: (e: any) => void;
}

const Notification: React.FC<IProps> = (_props: React.PropsWithChildren<IProps>) => {
  const { t } = useTranslation();
  const [initialized, setInitialized] = useState(false);

  const user: IUserCookieModel | null = useSelector((state: IStore) => state.auth.user);

  useEffect(() => {
    if (!user) {
      return;
    }
    try {
      const appId = getOneSignalEnv();

      if (!appId) {
        return;
      }

      OneSignal.init({
        appId: `${appId}`,
        notifyButton: {
          enable: true,
          prenotify: true,
          showCredit: false,
          text: {
            "dialog.main.title": "Subscribe to Notifications",
            "dialog.main.button.subscribe": "Subscribe",
            "dialog.main.button.unsubscribe": "Unsubscribe",
            "dialog.blocked.title": "Notifications Blocked",
            "dialog.blocked.message": "Please allow notifications in your browser settings",
            "message.action.subscribed": "Thanks for subscribing!",
            "message.action.resubscribed": "You are subscribed to notifications",
            "message.action.unsubscribed": "You will not receive notifications",
            "message.action.subscribing": "Subscribing...",
            "message.prenotify": "Click to subscribe to our notifications",
            "tip.state.subscribed": "You are subscribed to notifications",
            "tip.state.unsubscribed": "Subscribe to receive notifications",
            "tip.state.blocked": "Notifications are blocked",
          },
        },
      }).then(() => {
        setInitialized(true);
        OneSignal.Slidedown.promptPush();
      });
    } catch (e) {
      console.log("OneSignal Error", e);
    }

    // OneSignal SDK yüklendikten sonra Player ID'yi al
  }, [user]);

  const handleCancelOneSignal = () => {
    //console.log("CancelOneSignal");
    setInitialized(false);
    //OneSignal.setSubscription(false);
  };

  const handleSubscribeOneSignal = () => {
    //console.log("SubscribeOneSignal");
    //OneSignal.setSubscription(true);
    setInitialized(true);
  };

  const handleClicked = () => {
    if (!initialized) {
      handleSubscribeOneSignal();
    } else {
      handleCancelOneSignal();
    }
  };

  return (
    <li className="notification-li">
      <span>{t("general.notifications")}</span>
      <Form.Check
        style={{ padding: "10px" }}
        onChange={handleClicked}
        checked={initialized}
        type="switch"
        id="notification-switch"
      />
    </li>
  );
};

export default React.memo(Notification);
